import http from 'axios'
import store from './../store'
import { userAction } from './../store/action-names'
import VueCookie from 'vue-cookie'
import router from '@/router'
let jump = false
// 默认超时时间
http.defaults.timeout = 300000
// 启用全局 cookie
http.defaults.withCredentials = true

// 通用头部信息设置

// // http请求拦截器
// http.interceptors.request.use(config => {
//   return config
// }, error => {
//   return Promise.reject(error)
// })

// 响应拦截器
http.interceptors.response.use(response => {
  // console.log('http.interceptors: ', response)
  return response
}, error => {
  // console.log('http.interceptors: ', error, error.response)
  const response = error.response || {}
  if ((response.status === 401 || response.status === 302) && !jump) {
    jump = true
    setTimeout(() => {
      jump = false
    }, 500)
    // 未认证
    VueCookie.delete('_qd_emcp.l_s')
    store.dispatch(userAction.logout)
    router.push({path: response.headers.location || '/'})
  }
  return Promise.reject(error)
})

export default http



// WEBPACK FOOTER //
// ./src/utils/http.js